<section class="vc-admin-form-layout" [class.vc-admin-form-layout--compact]="compact">
  @if (titleKey || descriptionKey) {
    <header class="vc-admin-form-layout__header">
      @if (titleKey) {
        <h3>{{ titleKey | translate }}</h3>
      }

      @if (descriptionKey) {
        <p>{{ descriptionKey | translate }}</p>
      }
    </header>
  }

  <div class="vc-admin-form-layout__content">
    <ng-content></ng-content>
  </div>
</section>
